import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, FilledInput, InputAdornment, CircularProgress as Loader } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Email, People } from "@material-ui/icons";

import { registerNewUser } from "store/actions";

function SendOtp({ setEmail }) {
    const dispatch = useDispatch();

    const { isLoading } = useSelector(({ loading }) => ({
        isLoading: loading,
    }));

    return (
        <>
            <Formik
                initialValues={{
                    email: "",
                    name: "",
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().email("Must be a valid email").max(255).required("Email is required"),
                    name: Yup.string().required("Name is required"),
                })}
                onSubmit={async (value) => {
                    let response = await dispatch(registerNewUser(value));
                    if (response) {
                        setEmail(value);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
                    <form onSubmit={handleSubmit}>
                        <FilledInput
                            autoComplete="on"
                            type="email"
                            fullWidth
                            placeholder="Enter your email"
                            name="email"
                            defaultValue={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Email />
                                </InputAdornment>
                            }
                            required={true}
                            error={Boolean(touched.email && errors.email)}
                        />
                        {Boolean(touched.email && errors.email) ? (
                            <div
                                style={{
                                    display: "block",
                                    marginLeft: "10px",
                                    color: "red",
                                    fontSize: 13,
                                }}
                            >
                                {errors.email}
                            </div>
                        ) : (
                            ""
                        )}
                        <br />

                        <FilledInput
                            autoComplete="on"
                            type="text"
                            fullWidth
                            placeholder="Enter your name"
                            name="name"
                            defaultValue={values.name}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            startAdornment={
                                <InputAdornment position="start">
                                    <People />
                                </InputAdornment>
                            }
                            required={true}
                            error={Boolean(touched.name && errors.name)}
                        />
                        {Boolean(touched.name && errors.name) ? (
                            <div
                                style={{
                                    display: "block",
                                    marginLeft: "10px",
                                    color: "red",
                                    fontSize: 13,
                                }}
                            >
                                {errors.name}
                            </div>
                        ) : (
                            ""
                        )}
                        <br />

                        <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                            <Button id="signin-btn" color="primary" variant="contained" onClick={handleSubmit}>
                                {isLoading ? <Loader color="secondary" size={20} /> : "Continue"}
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
}

export default SendOtp;
